import PermissionGuard from 'components/Global/PermissionGuard';
import CoaTables from 'components/Settings/Coa';

export const Coa = () => {
	return (
		<PermissionGuard isAdmin={true}>
			<CoaTables />
		</PermissionGuard>
	);
};
